var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 45.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#040000;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.63,20.43a1.52,1.52,0,1,0-1.5-1.52A1.52,1.52,0,0,0,35.63,20.43Z",
    transform: "translate(-28.13 -12.57)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.63,12.57a7.56,7.56,0,0,0-7.5,7.6V32.84a7.5,7.5,0,1,0,15,0V20.17A7.56,7.56,0,0,0,35.63,12.57Zm6.5,20.27a6.5,6.5,0,1,1-13,0V20.17a6.5,6.5,0,1,1,13,0Z",
    transform: "translate(-28.13 -12.57)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.28,42.61l-6.65,6.74L29,42.61a.5.5,0,0,0-.7,0,.51.51,0,0,0,0,.72l7,7.09a.47.47,0,0,0,.35.15.49.49,0,0,0,.35-.15l7-7.09a.51.51,0,0,0,0-.72A.5.5,0,0,0,42.28,42.61Z",
    transform: "translate(-28.13 -12.57)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.28,49.71l-6.65,6.73L29,49.71a.48.48,0,0,0-.7,0,.5.5,0,0,0,0,.71l7,7.1a.47.47,0,0,0,.35.15.49.49,0,0,0,.35-.15l7-7.1a.5.5,0,0,0,0-.71A.48.48,0,0,0,42.28,49.71Z",
    transform: "translate(-28.13 -12.57)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollIcon);
export default __webpack_public_path__ + "static/media/scroll_icon.2451ac9d7c0164c5787622f899fa24a4.svg";
export { ForwardRef as ReactComponent };